import { render, staticRenderFns } from "./topicListDiaog.vue?vue&type=template&id=068009a8&"
import script from "./topicListDiaog.vue?vue&type=script&lang=js&"
export * from "./topicListDiaog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports